import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-training-answer-icon',
  templateUrl: './training-answer-icon.component.html',
  styleUrl: './training-answer-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrainingAnswerIconComponent {}
